import Vue from 'vue';
import LinkedinInboxAPI from '../../api/linkedinInbox';

const state = {
  records: {},
};

export const types = {
  SET_LINKEDIN_USAGE: 'SET_LINKEDIN_USAGE',
};

export const getters = {
  getUsage: $state => inboxId => $state.records[inboxId] || null,
};

export const actions = {
  fetch: async ({ commit }, inboxId) => {
    const response = await LinkedinInboxAPI.getUsage(inboxId).catch(() => null);
    if (!response) return;
    commit(types.SET_LINKEDIN_USAGE, { inboxId, usage: response.data });
  },
  set: ({ commit }, { inboxId, usage }) => {
    commit(types.SET_LINKEDIN_USAGE, { inboxId, usage });
  },
};

export const mutations = {
  [types.SET_LINKEDIN_USAGE]($state, { inboxId, usage }) {
    Vue.set($state.records, inboxId, usage);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
